import type {
  ActionOpenDetailsTimeline,
  VerticalTimelineItem as VerticalTimelineItemType,
} from '@yandex-delivery/types/schemas/services/cargo-c2c/definitions/timeline'
import React from 'react'

import {classes} from './VerticalTimeline.classes'
import {VerticalTimelineItem} from './VerticalTimelineItem'

type Props = {
  action: ActionOpenDetailsTimeline
}

export const VerticalTimeline: React.FC<Props> = ({action}) => {
  const lastActiveIndex = action.vertical.findLastIndex((item: VerticalTimelineItemType) => item.status === 'passed')
  // Находим последний активный элемент с иконкой (для spotlight)
  const lastActiveWithIconIndex = action.vertical.findLastIndex(
    (item: VerticalTimelineItemType) => item.status === 'passed' && item.icon_tag,
  )

  return (
    <div className={classes.container}>
      {/* Список элементов вертикального таймлайна */}
      {action.vertical.map((item, index) => (
        <VerticalTimelineItem
          index={index}
          isFirst={index === 0}
          isLast={index === action.vertical.length - 1}
          isLastActive={index === lastActiveIndex}
          isLastActiveWithIcon={index === lastActiveWithIconIndex}
          item={item}
          key={index}
          lastActiveIndex={lastActiveIndex}
        />
      ))}
    </div>
  )
}
